import { forEachNode, toggleCssClass } from '@/shared'

const btn = document.querySelectorAll('.js-toggle-trigger')

forEachNode(btn, (item) => {
  item.addEventListener('click', (e) => {
    e.preventDefault()

    const self = item.closest('.js-toggle')

    toggleCssClass(self, 'is-active')
  }, false)
})



// WEBPACK FOOTER //
// ./src/modules/toggle-content.js